/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDobbiesSideNavigationMenuData } from './dobbies-side-navigation-menu.data';
import { IDobbiesSideNavigationMenuProps } from './dobbies-side-navigation-menu.props.autogenerated';

export interface IDobbiesSideNavigationMenuViewProps extends IDobbiesSideNavigationMenuProps<IDobbiesSideNavigationMenuData> {}

/**
 *
 * DobbiesSideNavigationMenu component
 * @extends {React.PureComponent<IDobbiesSideNavigationMenuProps<IDobbiesSideNavigationMenuData>>}
 */
class DobbiesSideNavigationMenu extends React.PureComponent<IDobbiesSideNavigationMenuProps<IDobbiesSideNavigationMenuData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default DobbiesSideNavigationMenu;
